import React, { Component } from 'react';
import { Spin, message } from 'antd';
import Ueditor from '../../../common/Ueditor/Ueditor';
import FooterButton from './Components/FooterButton';
import { getNamesByLanguage } from '../constants';

let names = {};

class Background extends Component {
    state = {
        loading: false,
        editable: false,
        questionText: undefined,
    }

    componentDidMount() {
        const { status, language } = this.props;
        let editable = false;
        if (status === 'add') {
            editable = true;
        }
        this.setState({ editable });
        names = getNamesByLanguage('background', language);
    }

    uContentChange = (questionText) => {
        this.props.hasChange();
        this.setState({ questionText });
    }

    confirm = (shouldValidate) => {
        if (!shouldValidate) {
            this.props.changeStep(-1);
        } else {
            const { status } = this.props;
            status === 'add' && this.props.changeStep(1);
        }
    }

    toggleEditable = (editable) => {
        this.setState({ editable });
    }

    render() {
        const { status, height } = this.props;
        const { loading, editable, questionText } = this.state;
        return (
            <Spin spinning={loading}>
                <div className="quotation-content paddingBottom10" style={{ height }}>
                    <h2 className="quotation-title">{names.title}</h2>
                    <div style={{ marginTop: 10 }}>
                        <Ueditor id="quotationEditor" uContentChange={this.uContentChange} uContent={questionText} initialFrameHeight="460" initialFrameWidth="1100" />
                    </div>
                </div>
                <FooterButton
                    status={status}
                    editable={editable}
                    confirm={this.confirm}
                    toggleEditable={this.toggleEditable}
                />
            </Spin>
        );
    }
}

export default Background;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Background.js